// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Gq7tL","name":"Header_name__2_tKI","birthday":"Header_birthday__1tqDh","skeleton":"Header_skeleton__1BYHX"};